import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { ToolbarType } from "../action-columns/types/toolbar";
import { ApproveToolbar } from "./approvalToolbar";
import { MyAccessToolbar } from "./myAccessToolbar";
import { MyRequestToolbar } from "./myRequestToolbar";
import { MyTeamAccessToolbar } from "./myTeamAccessToolbar";
import { AccessProvisionersToolbar } from "./accessProvisionersToolbar";
import { EnvironmentToolbar } from "./mEnvironmentToolbar";
import { GsapToolbar } from "./mGsapToolbar";
import { SalesforceProfileToolbar } from "./mSalesforceProfileToolbar";
import { SalesforceRoleToolbar } from "./mSalesforceRoleToolbar";
import { RoleToolbar } from "./mRoleToolbar";
import { SystemAppNameToolbar } from "./mSystemAppNameToolbar";
import { InfrastructureToolbar } from "./mInfrastructureToolbar";
import { SystemTypeToolbar } from "./mSystemTypeToolbar";
import { EmployeeToolbar } from "./mEmployeeToolbar";
import { CategoryToolbar } from "./mCategoryToolbar";
import { UamToolbar } from "./mUamToolbar";
import { AccessAdminToolbar } from "./mAccessAdmin";
import { InfraAppToolbar } from "./mInfraAppToolbar";
import { ApproverDistroToolbar } from "./mApproverDistroToolbar";
import { FeedbackToolbar } from "./mFeedbackToolbar";
import { VIPToolbar } from "./mVIPToolbar";
import { AnnouncementsToolbar } from "./mAnnouncementsToolbar";
import { AnnouncementsSearchOnlyToolbar } from "./mAnnouncementsToolbarSearchOnly";
import { AccessAdminModalToolbar } from "./mAccessAdminModalToolbar";
import { LandingZonesToolbar } from "./mLandingZonesToolbar";
import { LandingZoneRolesToolbar } from "./mLandingZoneRolesToolbar";

interface Props {
  type: ToolbarType;
  toolbarProps: any;
  tableName: string;
}

export const Toolbar: React.FC<Props> = ({ type, toolbarProps, tableName }) => {
  let toolbar = null;
  switch (type) {
    case "APPROVE_TOOLBAR":
      toolbar = <ApproveToolbar {...toolbarProps} />;
      break;
    case "UAM_TOOLBAR":
      toolbar = <UamToolbar {...toolbarProps} />;
      break;
    case "MY_REQUEST_TOOLBAR":
      toolbar = <MyRequestToolbar {...toolbarProps} />;
      break;
    case "MY_TEAM_TOOLBAR":
      toolbar = <MyTeamAccessToolbar {...toolbarProps} />;
      break;
    case "MY_ACCESS_TOOLBAR":
      toolbar = <MyAccessToolbar {...toolbarProps} />;
      break;
    case "ACCESS_PROVISIONERS_TOOLBAR":
      toolbar = <AccessProvisionersToolbar {...toolbarProps} />;
      break;
    case "M_ENVIRONMENT_TOOLBAR":
      toolbar = <EnvironmentToolbar {...toolbarProps} />;
      break;
    case "M_SYSTEMTYPE_TOOLBAR":
      toolbar = <SystemTypeToolbar {...toolbarProps} />;
      break;
    case "M_EMPLOYEE_TOOLBAR":
      toolbar = <EmployeeToolbar {...toolbarProps} />;
      break;
    case "M_CATEGORY_TOOLBAR":
      toolbar = <CategoryToolbar {...toolbarProps} />;
      break;
    case "M_GSAP_TOOLBAR":
      toolbar = <GsapToolbar {...toolbarProps} />;
      break;
    case "M_SALESFORCE_PROFILE_TOOLBAR":
      toolbar = <SalesforceProfileToolbar {...toolbarProps} />;
      break;
    case "M_SALESFORCE_ROLE_TOOLBAR":
      toolbar = <SalesforceRoleToolbar {...toolbarProps} />;
      break;
    case "M_INFRA_APP_TOOLBAR":
      toolbar = <InfraAppToolbar {...toolbarProps} />;
      break;
    case "M_ACCESS_ADMIN_TOOLBAR":
      toolbar = <AccessAdminToolbar {...toolbarProps} />;
      break;
    case "M_SYSTEM_APPNAME_TOOLBAR":
      toolbar = <SystemAppNameToolbar {...toolbarProps} />;
      break;
    case "M_ROLE_TOOLBAR":
      toolbar = <RoleToolbar {...toolbarProps} />;
      break;
    case "M_INFRASTRUCTURE_TOOLBAR":
      toolbar = <InfrastructureToolbar {...toolbarProps} />;
      break;
    case "M_APPROVER_DISTRO_TOOLBAR":
      toolbar = <ApproverDistroToolbar {...toolbarProps} />;
      break;
    case "FEEDBACK_TOOLBAR":
      toolbar = <FeedbackToolbar {...toolbarProps} />;
      break;
    case "M_VIP_TOOLBAR":
      toolbar = <VIPToolbar {...toolbarProps} />;
      break;
    case "M_ANNOUNCEMENTS_TOOLBAR":
      toolbar = <AnnouncementsToolbar {...toolbarProps} />;
      break;
    case "M_ANNOUNCEMENTS_TOOLBAR_SEARCH":
      toolbar = <AnnouncementsSearchOnlyToolbar {...toolbarProps} />;
      break;
    case "M_ACCESS_ADMIN_MODAL_TOOLBAR":
      toolbar = <AccessAdminModalToolbar {...toolbarProps} />;
      break;
    case "M_LANDING_ZONES_TOOLBAR":
      toolbar = <LandingZonesToolbar {...toolbarProps} />;
      break;
    case "M_LANDING_ZONE_ROLES_TOOLBAR":
      toolbar = <LandingZoneRolesToolbar {...toolbarProps} />;
      break;
    default:
      toolbar = null;
  }

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <Typography variant="h6">{tableName}</Typography>
      </Grid>
      <Grid item xs={12}>
        {toolbar}
      </Grid>
    </Grid>
  );
};
